import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlHelperService } from '@core/services/url-helper.service';
import { BooleanResult } from '@core/interfaces/boolean-result.interface';

@Injectable()
export class AuthUserService {

  constructor(private http: HttpClient, private urlHelper: UrlHelperService) {
  }

  lookupSecurityRole(securityRoleId: number | undefined): any {
    var url = this.urlHelper.getApiUrl() + "SecurityRoleViewOnUserPage?SecurityRoleId=" + securityRoleId;
    return this.http.get(url);
  }
}
